/* eslint-disable jsx-a11y/img-redundant-alt */
// import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Pricing = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  // const pricingData = [
  //   { typology: "2 BHK Luxe", carpetArea: "1400" },
  //   { typology: "2 BHK Grande", carpetArea: "1675" },
  //   { typology: "3 BHK Luxe", carpetArea: "2200" },
  //   { typology: "3 BHK Grande", carpetArea: "2425" },
  //   { typology: "4 BHK Grande", carpetArea: "3000" },
  // ];
  return (
    <section className="section shadow-sm lazyloaded" id="pricing">
      <span className="section-link"></span>
      <h2 className="head text-capitalize text-center">
        {project} - Price Plan
      </h2>
      <div className="pricing-div text-center">
        {/* <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>1 BHK</h3>
          <h4>750 Sq. Ft.</h4>
          <button
            className="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            2.43 Cr* <small>Onwards</small>
          </button>
        </div> */}
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>2 BHK</h3>
          <h4>675 - 755 sq. ft*</h4>
          <button
            className="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            Price Breakup
          </button>
        </div>
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>3 BHK</h3>
          <h4>970 - 1202 sq. ft*</h4>
          <button
            className="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            Price Breakup
          </button>
        </div>
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>4 BHK</h3>
          <h4>1415 sq. ft*</h4>
          <button
            className="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            Price Breakup
          </button>
        </div>
      </div>
      {/* <div className="prc-tbl">
        <table>
          <tr>
            <th>Typology</th>
            <th>Carpet Area (Sq.Ft.)</th>
            <th>Price</th>
          </tr>
          {pricingData.map((item, index) => (
            <tr key={index}>
              <td>{item.typology}</td>
              <td>
                <button
                  className="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
              </td>
              <td>
                <button
                  className="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  Price Breakup
                </button>
              </td>
            </tr>
          ))}
        </table>
      </div> */}
    </section>
  );
};

export default Pricing;
